module.exports = __webpack_public_path__ + "static/petiole-72dd3e66437dcba4335fa9a6bff9783c.svg";